module.exports = __webpack_public_path__ + "img/Jacob.7e6f4e64.jpg";